import React from 'react';
import styled from '@emotion/styled';

import { deleteProject as apiDeleteProject } from '../utils/ApiUtilsV5';
import { ActionModal } from './ActionModal';

export const DeleteProjectModal = ({ project, onDeleted, onClose }) => (
  <ActionModal
    title="Delete project"
    submitLabel="Delete project"
    submittingLabel="Deleting…"
    submitVariant="danger"
    fallbackErrorMessage="Can't delete project"
    onSubmit={() =>
      apiDeleteProject(project.project_id).then(() => {
        onDeleted?.();
        onClose();
      })
    }
    onClose={onClose}
  >
    <Body>
      You are about to delete the project <strong>{project.name}</strong>. This
      action cannot be undone.
    </Body>
  </ActionModal>
);

const Body = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.fg.default};
`;
